export default __webpack_public_path__ + "static/media/team3.1c19cf78.jpg";